import api from "../../utils/API";

const getAllStatutsMissionForSelect = () => {
  return api.get(`/gestion/statutsmissionforselect/list`);
};

export {getAllStatutsMissionForSelect};
